import { gql } from '@apollo/client'

const SPONSOR_FIELDS = gql`
  fragment SponsorFields on Sponsor {
    name
  }
`

export { SPONSOR_FIELDS }
